import React from 'react';

const StarRating = ({ rating }) => {
    return (
        <div className="review-count rating">
            {[...Array(5)].map((_, i) => (
                <i
                    key={i}
                    className={`fa fa-star${i < rating ? ' filled' : ''}`}
                    style={{color: i < rating ? '#FFD700' : '#ccc'}}
                ></i>
            ))}
        </div>
    );
};

export default StarRating;
